// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__sIbA6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2tfDE"};